import React from "react";
import FormatDate from "./FormatDate.js";
import WeatherIcon from "./WeatherIcon.js";
import WeatherTemperature from "./WeatherTemperature.js";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <h1 className="col-6 city-name">{props.data.city}</h1>
      <div className="row">
        <div className="col-4 d-flex">
          <div className="float-left">
            <WeatherIcon
              code={props.data.icon}
              alt={props.data.description}
              size={52}
            />
          </div>
          <WeatherTemperature celsius={props.data.temperature} />
        </div>
        <div className="col-3 weather-data">
          <ul>
            <li>Feels like: {props.data.feels_like} °C</li>
            <li>Humidity: {props.data.humidity} %</li>
            <li>Wind: {props.data.windspeed} km/h</li>
          </ul>
        </div>
        <div className="col-5 weather-date">
          <ul>
            <li id="weather-id">Weather</li>
            <li>
              <FormatDate date={props.data.date} />
            </li>
            <li className="text-capitalize">{props.data.condition}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/WeatherInfo.js